import { useQuery } from "@tanstack/react-query"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { httpClient } from "~/backend/axios"

export const useListMaterialTypesQuery = () =>
  useQuery(["materialTypes"], async () => {
    const res = await httpClient.get<AdminResponses.MaterialTypes[]>(
      "/admin/material-types"
    )
    return res.data
  })
